import { firebase, firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import filterUndefined from '../utilities/Data/filterUndefined'

const updateUserProfile = async (props) => {
	try {
		// remove any undefined values
		const userProfile = filterUndefined(props.userProfile)

		// Remove any images array before storing
		delete userProfile.images

		// timestamp
		userProfile.modifiedTimestamp = firebase.firestore.FieldValue.serverTimestamp()

		await firestore.collection('userProfiles').doc(userProfile.uid).update(userProfile)
		return { userProfile }
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, exception)
	}
}
export default updateUserProfile



// WEBPACK FOOTER //
// ./src/dataservices/updateUserProfile.js